import * as React from "react"
import { Order } from "BookingSystem/db/Order"
import { Flex } from "rebass"
import theme from "../../theme"

export class OrderDetail extends React.Component<{ model: Order }> {
  render() {
    const { model } = this.props
    const order = model
    return (
      <Flex
        flexDirection="column"
        bg={theme.colors.white}
        color={theme.colors.black}
        style={{
          fontFamily: theme.fonts.tertiary,
          textTransform: "uppercase"
        }}
        p={"0.5em 0.75em"}
      >
        <Flex
          justifyContent="center"
          alignItems="flex-start"
          width={1}
          fontSize={["1rem", "1.25rem", "1.5rem"]}
          style={{ fontWeight: 800 }}
        >
          Order Details
        </Flex>
        <Flex
          justifyContent="center"
          alignItems="center"
          width={1}
          p={"0.5em 0.75em"}
        >
          {`Date Visiting: ${order.displayDate}`}
        </Flex>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: "solid 2px rgba(0,0,0,0.1)", minHeight: 41 }}
        >
          <Flex width={0.6} p={"0.5em 0.75em"}>
            Description
          </Flex>
          <Flex width={0.15} p={"0.5em 0.75em"}>
            Qty.
          </Flex>
          <Flex width={0.25} p={"0.5em 0.75em"}>
            Amount
          </Flex>
        </Flex>
        {order.lineItems &&
          order.lineItems.map((lineItem, i) => {
            return (
              <Flex
                key={i}
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                style={{
                  borderBottom: "solid 2px rgba(0,0,0,0.1)",
                  minHeight: 41
                }}
              >
                <Flex width={0.6} p={"0.5em 0.75em"} flexDirection="column">
                  <Flex>{lineItem.object.fullName}</Flex>
                  <Flex fontSize={[14]}>
                    {lineItem.object.passNumber
                      ? `${lineItem.object.passNumber}: ${
                          lineItem.object.sessionTypeName
                        } ${lineItem.object.sessionTime}`
                      : `${lineItem.object.sessionTypeName} ${
                          lineItem.object.sessionTime
                        }`}
                  </Flex>
                </Flex>
                <Flex
                  width={0.15}
                  style={{ textAlign: "center" }}
                  justifyContent="center"
                >
                  {lineItem.object.quantity}
                </Flex>
                <Flex width={0.25} p={"0.5em 0.75em"} justifyContent="flex-end">
                  ${lineItem.totalFriendly}
                </Flex>
              </Flex>
            )
          })}
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: "solid 2px rgba(0,0,0,0.1)", minHeight: 41 }}
        >
          <Flex width={0.75} p={"0.5em 0.75em"}>
            Tax
          </Flex>
          <Flex width={0.25} p={"0.5em 0.75em"} justifyContent="flex-end">
            ${order.taxFriendly}
          </Flex>
        </Flex>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: "solid 2px rgba(0,0,0,0.1)", minHeight: 41 }}
        >
          <Flex width={0.75} p={"0.5em 0.75em"}>
            Total
          </Flex>
          <Flex width={0.25} p={"0.5em 0.75em"} justifyContent="flex-end">
            ${order.totalFriendly}
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
